import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[backgroundImage]'
})
export class BackgroundImageDirective {

  @Input() set backgroundImage(src: string) {
    this.el.nativeElement.style.backgroundImage = `url('${src}')`
  }
  @Input() set translateY(offset: number) {
    this.el.nativeElement.style.transform = `translateY(${offset}px)`
  }

  constructor(private el: ElementRef<HTMLDivElement>) { }

}
